import { DomainVisitors } from '@/modules/Domains';
import { RedirectEndpointEnum, RedirectEndpointType, RedirectMatchMode, Site } from '@/modules/Sites';

export type RedirectNodeRef = { id: string; path: string };

export type Redirect = {
  id: string;
  sourceType: RedirectEndpointType;
  sourceNodeId: string | null;
  sourceNode: RedirectNodeRef | null;
  sourcePath: string | null;
  targetType: RedirectEndpointType;
  targetNodeId: string | null;
  targetNode: RedirectNodeRef | null;
  targetPath: string | null;
  statusCode: number;
  matchMode: RedirectMatchMode;
  forVisitor: DomainVisitors;
  isActive: boolean;
  site: Pick<Site, 'id' | 'name'>;
  createdAt: Date;
  updatedAt: Date;
}

export const getRedirectSourceLabel = (redirect: Pick<Redirect, 'sourceType' | 'sourceNode' | 'sourcePath'>): string =>
  redirect.sourceType === RedirectEndpointEnum.Node ? (redirect.sourceNode?.path ?? '') : (redirect.sourcePath ?? '');

export const getRedirectTargetLabel = (redirect: Pick<Redirect, 'targetType' | 'targetNode' | 'targetPath'>): string =>
  redirect.targetType === RedirectEndpointEnum.Node ? (redirect.targetNode?.path ?? '') : (redirect.targetPath ?? '');
